<template>
  <div>
    <div class="flex-container">
      <div id="dashboard1" class="oberstatus">
        <div id="greeting">
          <div class="imgcon">
            <b-img :src="imageSrc" class="mr-3"/>
            <router-link class="item" to="/home/profile"><a href="" class="setting">
              <b-icon icon="gear"></b-icon>
            </a></router-link>
          </div>
          <div class="greetingtext">
            <p> Willkommen zurück <b> {{ username }} </b>!</p>
            <p>Come here to check in with your favorite communities.
            </p>
            <router-link class="item" to="/home/events/create">
              <button class="newevent">Neues Event erstellen</button>
            </router-link>
          </div>
        </div>
      </div>
      <div id="dashboard2" class="oberstatus">
        <div id="progresspath">
          <h2> Deine Progression</h2>
          <ol class="user-progress">
            <li class="active">
              <b-icon icon="type-h1"></b-icon>
              <a>Anfänger</a></li>
            <li class="active">
              <b-icon icon="type-h2"></b-icon>
              <a>Amateur</a></li>
            <li class="">
              <b-icon icon="type-h3"></b-icon>
              <a>Profi</a></li>
            <li class="">
              <b-icon icon="shield-lock"></b-icon>
              <a>Meister</a></li>
          </ol>
        </div>
      </div>
    </div>
    <h2> Anstehende Events</h2>
    <event-list :events="eventParticipate" :user-view="true"/>
  </div>
</template>

<script>
import {imageService} from "@/services/image.service";
import EventList from "../EventList";
import {eventService} from "@/services/event.service";

export default {
  name: 'DashboardUser',
  data() {
    return {
      imageSrc: null,
      eventParticipate: []
    }
  },
  created() {
    imageService.getImage().then(resp => {
      this.imageSrc = resp.path
    });
    eventService.getEventsNew(999,0, {type:"own",sort:"date"}).then( res =>
        {
          this.eventParticipate = res.items
        }
    )
  },
  methods: {},
  computed: {
    username() {
      return localStorage.getItem('username')
    }
  },
  components: {
    EventList
  }
}
</script>

<style scoped>
/*----------- Content Statusleiste  -----------*/

.flex-container {
  margin-bottom: 30px;
}

.oberstatus {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 10px;
  border: 1px #ddd solid;
  border-radius: 5px;
  width: 100%;
  margin: 10px;
  flex: 1 0;
}

#dashboard1 {
  flex-basis: 200px;
}

#dashboard2 {
  flex: 2 0;
}

/*----------- Greeting  -----------*/

#greeting {
  display: flex;
  align-items: center;
}

#greeting .imgcon {
  max-width: 80px;
  max-height: 80px;
  border-radius: 50%;
  border: 2px dashed rgb(221, 221, 221);
  float: left;
  vertical-align: top;
  flex-shrink: 0;
  position: relative;
}

.imgcon .setting {
  display: inline-block;
  position: absolute;
  top: 50px;
  right: -10px;
  border-radius: 50%;
  padding: 4px;
  background-color: var(--green);
  color: white;
  line-height: 0;
}

.imgcon img {
  width: 100%;
  max-width: 80px;
  max-height: 80px;
  border-radius: 50%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  display: block;
  object-fit: cover;
}

.greetingtext {
  padding: 20px;
  text-align: justify;
  width: 100%;
}

/*----------- Lernpfad -----------*/
#progresspath {
  width: 100%;
}

#progresspath h2 {
  margin-bottom: 20px;
}

#progresspath .user-progress {
  margin: 0;
  padding: 10px 0 0 0;
  counter-reset: step;
}

#progresspath .user-progress li {
  list-style-type: none;
  width: 25%;
  float: left;
  font-size: 12px;
  position: relative;
  text-align: center;
  color: #7d7d7d;
  margin-bottom: 20px ;
}

#progresspath .user-progress li::before {
  width: 30px;
  height: 30px;
  content: counter(step);
  counter-increment: step;
  line-height: 25px;
  border: 2px solid grey;
  display: block;
  text-align: center;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  background-color: white;
}

#progresspath .user-progress li::after {
  width: 100%;
  height: 2px;
  content: '';
  position: absolute;
  background-color: #7d7d7d;
  top: 15px;
  left: -50%;
  z-index: -1;
}

#progresspath .user-progress li.active {
  color: green;
  font-weight: bold;
}

#progresspath .user-progress li.active::before {
  border-color: green;
}

#progresspath .user-progress li.active + li::after {
  background-color: green;
}

#progresspath .user-progress li:first-child:after {
  content: none;
}

#progresspath .user-progress li a {
  padding-left: 6px;
  display: inline-block;
}


@media screen and (max-width: 768px) {
  .flex-container {
    flex-direction: column;
    justify-content: center;
  }
}
</style>
